webpackJsonp([2],{

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_movieDetails_vue__ = __webpack_require__(1092);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e3b7f4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_movieDetails_vue__ = __webpack_require__(1137);
function injectStyle (ssrContext) {
  __webpack_require__(1133)
  __webpack_require__(1135)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e3b7f4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_movieDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e3b7f4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_movieDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,DQoNCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDMyIDMyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMiAzMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGcgaWQ9ImNhbGVuZGFyXzFfIj4NCgkJPHBhdGggc3R5bGU9ImZpbGw6I2ZmZmZmZjsiIGQ9Ik0yOS4zMzQsM0gyNVYxYzAtMC41NTMtMC40NDctMS0xLTFzLTEsMC40NDctMSwxdjJoLTZWMWMwLTAuNTUzLTAuNDQ4LTEtMS0xcy0xLDAuNDQ3LTEsMXYySDlWMQ0KCQkJYzAtMC41NTMtMC40NDgtMS0xLTFTNywwLjQ0Nyw3LDF2MkgyLjY2N0MxLjE5NCwzLDAsNC4xOTMsMCw1LjY2NnYyMy42NjdDMCwzMC44MDYsMS4xOTQsMzIsMi42NjcsMzJoMjYuNjY3DQoJCQlDMzAuODA3LDMyLDMyLDMwLjgwNiwzMiwyOS4zMzNWNS42NjZDMzIsNC4xOTMsMzAuODA3LDMsMjkuMzM0LDN6IE0zMCwyOS4zMzNDMzAsMjkuNzAxLDI5LjcwMSwzMCwyOS4zMzQsMzBIMi42NjcNCgkJCUMyLjI5OSwzMCwyLDI5LjcwMSwyLDI5LjMzM1Y1LjY2NkMyLDUuMjk5LDIuMjk5LDUsMi42NjcsNUg3djJjMCwwLjU1MywwLjQ0OCwxLDEsMXMxLTAuNDQ3LDEtMVY1aDZ2MmMwLDAuNTUzLDAuNDQ4LDEsMSwxDQoJCQlzMS0wLjQ0NywxLTFWNWg2djJjMCwwLjU1MywwLjQ0NywxLDEsMXMxLTAuNDQ3LDEtMVY1aDQuMzM0QzI5LjcwMSw1LDMwLDUuMjk5LDMwLDUuNjY2VjI5LjMzM3oiLz4NCgkJPHJlY3QgeD0iNyIgeT0iMTIiIHN0eWxlPSJmaWxsOiNmZmZmZmY7IiB3aWR0aD0iNCIgaGVpZ2h0PSIzIi8+DQoJCTxyZWN0IHg9IjciIHk9IjE3IiBzdHlsZT0iZmlsbDojZmZmZmZmOyIgd2lkdGg9IjQiIGhlaWdodD0iMyIvPg0KCQk8cmVjdCB4PSI3IiB5PSIyMiIgc3R5bGU9ImZpbGw6I2ZmZmZmZjsiIHdpZHRoPSI0IiBoZWlnaHQ9IjMiLz4NCgkJPHJlY3QgeD0iMTQiIHk9IjIyIiBzdHlsZT0iZmlsbDojZmZmZmZmOyIgd2lkdGg9IjQiIGhlaWdodD0iMyIvPg0KCQk8cmVjdCB4PSIxNCIgeT0iMTciIHN0eWxlPSJmaWxsOiNmZmZmZmY7IiB3aWR0aD0iNCIgaGVpZ2h0PSIzIi8+DQoJCTxyZWN0IHg9IjE0IiB5PSIxMiIgc3R5bGU9ImZpbGw6I2ZmZmZmZjsiIHdpZHRoPSI0IiBoZWlnaHQ9IjMiLz4NCgkJPHJlY3QgeD0iMjEiIHk9IjIyIiBzdHlsZT0iZmlsbDojZmZmZmZmOyIgd2lkdGg9IjQiIGhlaWdodD0iMyIvPg0KCQk8cmVjdCB4PSIyMSIgeT0iMTciIHN0eWxlPSJmaWxsOiNmZmZmZmY7IiB3aWR0aD0iNCIgaGVpZ2h0PSIzIi8+DQoJCTxyZWN0IHg9IjIxIiB5PSIxMiIgc3R5bGU9ImZpbGw6I2ZmZmZmZjsiIHdpZHRoPSI0IiBoZWlnaHQ9IjMiLz4NCgk8L2c+DQo8L2c+DQoNCjwvc3ZnPg0K"

/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1080:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_partials_UpComingMovies_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_storage_service__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuelidate__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_partials_advertise_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__helper_constant_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helper_constant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helper_constant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__helper_constant__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import StarRating from "vue-star-rating";
// Vue.component("star-rating", StarRating);









// var async = require("async");

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    // Filter: {
    //   type: Object,
    //   default: {}
    // },

    cat_id: {
      type: String,
      default: ""
    },
    userReview: {
      type: Boolean,
      default: false
    }
  },
  name: "movieDetails",
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_8_vue_slick__["default"],
    UpCommingMovies: __WEBPACK_IMPORTED_MODULE_9__components_partials_UpComingMovies_vue__["a" /* default */],
    Advertise: __WEBPACK_IMPORTED_MODULE_14__components_partials_advertise_vue__["a" /* default */]
  },

  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_16_moment___default.a,
      ratingContent: null,
      selected_timingList: null,
      selected_allShowTimes: null,
      AvailableSeats: 0,
      CinemaAPIPath: "/GetCinemaSchedule",
      jsonld: "",
      project: __WEBPACK_IMPORTED_MODULE_15__helper_constant_js__["PROJECT"],
      shareURL: "",
      pageTitle: "Movie Details",
      ratingDetails: {
        currentUserRating: 0
      },
      filterModal: false,
      msg: "Welcome to Your HOMEPAGE",
      slickOptions: {
        slidesToShow: 3
      },
      shows: [1],
      tempShows: [],
      isShowsLoaded: false,
      allShows: [],
      youtubeURL: "i4K3os977h4",
      movieDetails: {},
      allDates: [],
      language: [],
      format: [],
      allcinemas: [],
      selectedDate: "Show Date",
      selectedCinema: "All Cinemas",
      selectedFormat: "All Formats",
      selectedLanguage: "All Language",
      movieID: "",
      movie_language: "",
      userId: "",
      youtubes: [],
      trailer: {
        url: "",
        thumbnail: ""
      },
      favChecked: false,
      filters: [],
      isSuccess: false,
      dateFilter: null,
      selectedFilter: {},
      rating: {
        userRatings: [],
        criticRatings: [],
        userRating: 0,
        currentUserRatingDetails: {
          title: "",
          currentUserRating: 0,
          content: ""
        },
        _currentUserRatingDetails: {
          title: "",
          currentUserRating: 0,
          content: ""
        },
        criticRating: 0,
        AvgRating: 0,
        criticRatingDetails: [],
        currentUserRating: {}
      },
      allShowingEvents: [],
      event_img_base_url: "",
      reviewSuccessMessage: "",
      selectedOrgId: "0",
      reviewdId: "",
      reportReviewMessage: "",
      reviewErrorMessage: "",
      ratingMessage: "",
      userRating: "",
      isError: "",
      cinemaID: "",
      loggedIn: false,
      tabIndex: 0,
      SeatTypes: [],
      SeatTypesValue: "",
      Currency: "",
      show: false,
      ShowLang: [],
      count: 0,
      categoryId: "",
      filtersChips: [],
      filterData: [],
      timingList: null,
      allShowTimes: [],
      countryID: "",
      languageID: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["mapGetters"])(["isRTL"])),
  metaInfo: function metaInfo() {
    return {
      title: "Book Movie Tickets For " + this.pageTitle + " | " + this.pageTitle + " Movie Tickets"
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13_vuelidate__["validationMixin"]],

  beforeMount: function beforeMount() {
    this.movieID = this.$route.params.movieID;
    this.cinemaID = this.$route.params.cinemaID;
    this.countryID = this.$route.params.CountryID;
    this.languageID = this.$route.params.LanguageID;

    this.fetchMovieDetails();
    this.fetchUserReview();
    this.fetchCtricReview();
    this.getAllFilters();
    this.getAllData();
    this.$cookies.set("retry_type", "movie", "1d");
    this.$cookies.set("retry_id", this.movieID, "1d");
    // this.fetchUserFav();
  },

  // destroyed() {
  //   if (this.$attrs.props && this.$attrs.props.selectedFilter) {
  //     this.$attrs.props.selectedFilter = {};
  //   }
  // },
  beforeDestroy: function beforeDestroy() {
    this.secureStore.remove("SF");
  },
  created: function created() {
    window.addEventListener("beforeunload", this.handler);
  },
  mounted: function mounted() {
    if (true) {}
    //this.$refs.coronaPopup.show();

    // if (this.CinemaAPIPath) {
    //   //this.CinemaAPIPath = "/GetCinemaSchTK";
    //   this.CinemaAPIPath = "/GetCinemaSchedule";
    // }
    var country = __WEBPACK_IMPORTED_MODULE_11__services_storage_service__["CountryService"].getCountry();
    if (country) {
      //do nothing
    } else {
      this.getCountryList();
    }
    this.shareURL = window.location.href;
    // this.$refs.tncModal.show();
    this.dateFilter = this.secureStore.get("SF");
    console.log("this.dateFilter :", this.dateFilter);
    // console.log("this.selectedFilter in mounted:", this.selectedFilter);
    // this.$root.$on("bv::tooltip::show", bvEvent => {
    //   console.log("bvEvent:", bvEvent);
    // });
    if (__WEBPACK_IMPORTED_MODULE_11__services_storage_service__["TokenService"].getToken()) {
      this.loggedIn = true;
    }
    // branch.init("key_live_lgSDutp4w6xV8GnFUq8FYgebxskAtqf9", function(
    //   err,
    //   data
    // ) {
    //   console.log(err, data);
    // });
    console.log("this.$attrs :", this.$attrs);
    if (this.$attrs.props && this.$attrs.props.cat_id) {
      this.categoryId = this.$attrs.props.cat_id;
    }
    var linkData = {
      data: {
        $desktop_url: window.location.origin + this.$route.fullPath
      }
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.movieID = this.$route.params.movieID;
      this.cinemaID = this.$route.params.cinemaID;

      this.fetchMovieDetails();
      this.fetchUserReview();
      this.fetchCtricReview();
      this.getAllFilters();
    }
  },
  methods: {
    getSeatType: function getSeatType(show) {
      // this.onHoverShowTime(show);
      console.log(show);
    },
    checkLateNightPopup: function checkLateNightPopup(data, timingListNew, timingList) {
      var _this = this;

      if (data) {
        // const t = this.$refs.LateNightPopup.show();
        __WEBPACK_IMPORTED_MODULE_7__main__["EventBus"].$on("timingList", function (user) {
          _this.onAccept(timingListNew, timingList);
        });
        this.$refs.LateNightPopup.show();
      } else {
        this.onAccept(timingListNew, timingList);
      }
    },
    closeLateNightPopup: function closeLateNightPopup() {
      __WEBPACK_IMPORTED_MODULE_7__main__["EventBus"].$emit("timingList");
    },
    setShows: function setShows(orgId) {
      this.showLoading();
      this.shows = this.tempShows;

      this.selectedOrgId = orgId;

      if (orgId == "0") {
        this.getAllFilters();

        return false;
      }
      var selectedOrgCinemasShows = this.shows.filter(function (y) {
        return y.OrganizationID == orgId;
      });

      if (selectedOrgCinemasShows.length > 0) {
        this.shows = selectedOrgCinemasShows;
      } else {
        this.shows = [];
      }

      this.getAllFilters();
    },

    handler: function handler() {
      this.secureStore.remove("SF");
    },
    getCountryList: function getCountryList() {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/GetCountryList", "POST", null, {}).then(function (result) {
        var _response = response,
            error = _response.error,
            res = _response.res;

        if (res.data.Status) {
          res.data.List.map(function (country) {
            if (_this2.countryID == country.CountryID) {
              __WEBPACK_IMPORTED_MODULE_11__services_storage_service__["CountryService"].saveCountry(country);
            }
          });
        }
      }).catch(function (err) {});
    },
    onCancel: function onCancel() {
      this.$refs.tncModal.hide();
    },
    onAccept: function onAccept(timingList, _allShowTimes) {
      this.selected_timingList = timingList;
      this.selected_allShowTimes = _allShowTimes;
      console.log("onAccept", { timingList: timingList, _allShowTimes: _allShowTimes });
      this.$forceUpdate();

      if (this.ratingContent !== null) {
        // this.$refs.tncModal && this.$refs.tncModal.show();
        this.show = false;
        this.timingList = this.selected_timingList;
        this.allShowTimes = this.selected_allShowTimes.map(function (x) {
          x["ShowTime"] = x.time;
          x["SchID"] = x.id;
          x["Format"] = x.format;
          return x;
        });
        this.$router.push({
          name: "checkout",
          params: {
            movieID: this.movieID,
            scheduleID: this.selected_timingList.id,
            seatLayout: this.selected_timingList.seatlayout,
            props: { allShowTimes: this.allShowTimes }
          }
        });
      } else {
        if (timingList.hover) {
          this.show = false;
          this.timingList = timingList;
          this.allShowTimes = _allShowTimes.map(function (x) {
            x["ShowTime"] = x.time;
            x["SchID"] = x.id;
            x["Format"] = x.format;
            return x;
          });

          console.log(this.movieID, timingList.id, timingList.seatlayout, "jj");
          this.$router.push({
            name: "checkout",
            params: {
              movieID: this.movieID,
              scheduleID: timingList.id,
              seatLayout: timingList.seatlayout,
              props: { allShowTimes: this.allShowTimes }
            }
          });
          // this.$refs.tncModal.show();
        }
      }
    },
    onClickCinemaTime: function onClickCinemaTime() {
      console.log("onClickCinemaTime");
      // this.$router.push({
      //   name: "checkout",
      //   params: {
      //     movieID: movieID,
      //     scheduleID: timingList.id,
      //     seatLayout: timingList.seatlayout,
      //     props: { allShowTimes: this.allShowTimes }
      //   }
      // });

      this.show = false;
      this.timingList = this.selected_timingList;
      this.allShowTimes = this.selected_allShowTimes.map(function (x) {
        x["ShowTime"] = x.time;
        x["SchID"] = x.id;
        x["Format"] = x.format;
        return x;
      });
      this.$router.push({
        name: "checkout",
        params: {
          movieID: this.movieID,
          scheduleID: this.selected_timingList.id,
          seatLayout: this.selected_timingList.seatlayout,
          props: { allShowTimes: this.allShowTimes }
        }
      });
    },
    setLanguage: function setLanguage(Lang, index) {
      this.youtubes = [];
      this.movie_language = Lang.LanguageID;

      var selectedMovie = this.movieDetails.links.filter(function (y) {
        return y.LanguageID == Lang.LanguageID;
      });

      if (selectedMovie.length > 0) {
        this.movieDetails.lang = selectedMovie[0].Title;
        this.movieDetails.movie_card_img = selectedMovie[0].movie_card_img;

        this.trailer.url = selectedMovie[0].Youtube;
        this.youtubes.push({
          thumbnail: "https://img.youtube.com/vi/" + selectedMovie[0].Youtube + "/0.jpg",
          url: "https://www.youtube.com/watch?v=" + selectedMovie[0].Youtube
        });

        //this.selected_movie_Title_lang=selectedMovie[0].Title
      }

      console.log(this.movieDetails, "lang");
      // this.selectedFilter["movie_language"] = [Lang.LanguageID];
      //  this.onClickFilter("movie_language", Lang.LanguageID, index, Lang.Title);
      // this.selectedFilter["show_date"] = [
      //         this.filters[3].all_filter[0].value
      //       ];
      this.getShowTimings();
      this.$refs.LangModal.hide();
    },
    onHoverShowTime: function onHoverShowTime(showtime) {
      var _this3 = this;

      if (showtime.hover) {
        this.SeatTypes = [];
        var payload = {
          SchID: showtime.id
        };
        console.log(payload);
        Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/GetSeatType", "POST", null, payload).then(function (response) {
          var error = response.error,
              res = response.res;
          //res.data.Status = false;

          if (res.data.Status) {
            _this3.showLoading();

            _this3.SeatTypes = res.data.SeatTypes;
            _this3.Currency = res.data.Currency;
            _this3.show = true;
            _this3.AvailableSeats = res.data.AvailableSeats;
            console.log(_this3.AvailableSeats);
            _this3.hideLoading();
          } else {
            _this3.$toasted.show("Booking is not available");
            setTimeout(function () {
              _this3.$toasted.clear();
            }, 1000);
            //this.SeatTypes[0]["SeatType"] = "Booking is not available";
            //this.show = true;
          }
        }).catch(function (error) {
          console.log("Error", error);
        });
        // console.log("showtime :", showtime);
      } else {
        this.SeatTypesValue = showtime.hover_message;
      }
    },
    onClickAbuseFlag: function onClickAbuseFlag(rating) {
      var _this4 = this;

      var token = __WEBPACK_IMPORTED_MODULE_11__services_storage_service__["TokenService"].getToken();
      if (!token) {
        this.checkSignIn();
      } else {
        this.reviewdId = rating.ID;
        var payload = {
          RatingID: rating.ID
        };
        Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/FlagAbuse", "POST", token, payload).then(function (response) {
          var error = response.error,
              res = response.res;

          _this4.reportReviewMessage = res.data.Message;
        }).catch(function (error) {
          _this4.reviewErrorMessage = "Something went wrong!";
          console.log("Error", error);
        });
        setTimeout(function () {
          _this4.reportReviewMessage = "";
        }, 3000);
      }
    },
    titleCase: function titleCase(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(" ");
    },

    onToggle: function onToggle(index) {
      this.$root.$emit("bv::toggle::collapse", index);
    },
    onClickFilter: function onClickFilter(filter_key, value, index, title) {
      // this.showLoading();
      this.movie_language = "";

      var obj = {};
      obj[filter_key] = [];

      this.selectedFilter = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, obj, this.selectedFilter);
      var _index = this.selectedFilter[filter_key].indexOf(value);
      if (filter_key == "show_date") {
        this.selectedDate = title;
        this.selectedFilter[filter_key] = [value];
        this.onToggle("collapse-1");
      } else {
        //filterchips
        var __index = this.filtersChips.findIndex(function (x) {
          return x.title === title;
        });

        if (__index > -1) {
          this.filtersChips.splice(__index, 1);
        } else {
          this.filtersChips.push({
            title: title,
            filter_key: filter_key,
            value: value
          });
        }
        //
        if (_index > -1) {
          this.selectedFilter[filter_key].splice(_index, 1);
        } else {
          this.selectedFilter[filter_key].push(value);
        }
      }
      this.getShowTimings();
    },
    onClearAllFilters: function onClearAllFilters() {
      this.filtersChips = [];
      this.selectedFilter = {};
      this.selectedFilter["show_date"] = [this.filters[0].all_filter[0].value];
      this.selectedDate = this.filters[0].all_filter[0].title;
      this.getShowTimings();
    },
    onRemoveFilterChips: function onRemoveFilterChips(filter_key, value, index) {
      this.filtersChips.splice(index, 1);
      var _index = this.selectedFilter[filter_key].indexOf(value);

      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      }
      this.getShowTimings();
    },

    filterShowData: function filterShowData(data, filter) {
      if (filter == "date") {
        this.selectedDate = data;
        this.selectedDate.Date = data.ShowDate;
        this.getShowTimings();
        this.getCinemas(data.ID);
        this.filterShowData("All Cinemas", "cinema");
      }
      if (filter == "cinema") {
        this.selectedCinema = data;
        if (data == "All Cinemas") {
          this.shows = this.allShows;
        } else {
          this.shows = this.allShows.filter(function (x) {
            return x.name === data;
          });
        }
      }
      if (filter == "format") {
        this.selectedFormat = data;
        if (data == "All Formats") {
          this.shows = this.allShows;
        } else {
          this.filterAllData();
        }
      }
      if (filter == "languaeg") {
        this.selectedLanguage = data;
        this.filterAllData();
      }
    },
    filterAllData: function filterAllData() {
      var _this5 = this;

      this.shows.map(function (cinema) {
        cinema.timings.filter(function (timing) {
          if (timing.format === _this5.selectedFormat) {
            return cinema;
          } else if (cinema.name === _this5.selectedCinema) {
            return cinema;
          } else if (timing.name == _this5.selectedLanguage) {
            return cinema;
          }
        });
      });
      // console.log("hererererere", this.filterAllData);
    },
    checkSignIn: function checkSignIn() {
      __WEBPACK_IMPORTED_MODULE_7__main__["EventBus"].$emit("openSignInModal");
    },

    getAllFilters: function getAllFilters() {
      var _this6 = this;

      this.filters = [];
      var self = this;
      var payload = {
        FilterType: "Movie",
        MovieID: this.movieID,
        OrganizationID: 3
      };
      if (this.cinemaID != "" && this.cinemaID > 0) {
        payload["CinemaID"] = this.cinemaID;
      }

      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/GetAllFilter", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error) {
          _this6.hideLoading();
          if (res.data.Filters[0].all_filter.length > 0) {
            self.filters = [];

            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([_function1]).then(function (values) {
              self.getShowTimings();
            }).catch(function (error) {
              self.getShowTimings();
            });

            var _function1 = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              res.data.Filters.map(function (x, index) {
                self.filters.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
                  collapseId: "collapse-" + (index + 1)
                }));
              });

              self.selectedFilter = [];
              if (self.$attrs.props && self.$attrs.props.selectedFilter) {
                self.selectedFilter = self.$attrs.props.selectedFilter;
              }

              var date_value = self.filters[0].all_filter[0].value;
              var date_title = self.filters[0].all_filter[0].title;
              self.filters[0].all_filter.map(function (x, index) {
                var a = __WEBPACK_IMPORTED_MODULE_16_moment___default.a.unix(x.value).format("YYYY-MM-DD");
                var b = self.dateFilter && self.dateFilter.show_date && self.dateFilter.show_date.length > 0 ? __WEBPACK_IMPORTED_MODULE_16_moment___default.a.unix(self.dateFilter.show_date[0]).format("YYYY-MM-DD") : null;

                if (b && __WEBPACK_IMPORTED_MODULE_16_moment___default()(a).isSame(__WEBPACK_IMPORTED_MODULE_16_moment___default()(b))) {
                  date_value = self.filters[0].all_filter[index].value;
                  date_title = self.filters[0].all_filter[index].title;
                  self.selectedFilter["show_date"] = date_value;
                  self.selectedDate = date_title;
                } else {
                  self.selectedFilter["show_date"] = date_value;
                  self.selectedDate = date_title;
                }
              });

              if (self.$attrs.props && self.$attrs.props.selectedFilter) {
                self.selectedFilter = self.$attrs.props.selectedFilter;

                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(self.selectedFilter).map(function (x) {
                  self.filters.map(function (z) {
                    z.all_filter.map(function (y) {
                      if (x == z.filter_key && self.selectedFilter[x] == y.value) {
                        self.filtersChips.push({
                          title: y.title,
                          filter_key: y.filter_key,
                          value: y.value
                        });
                      } else {}
                    });
                  });
                });
              }
              resolve(self.selectedFilter);
            });
          }
        } else {
          _this6.hideLoading();
          console.log("Response Error ");
        }
      }).catch(function (error) {
        _this6.hideLoading();
        console.log("Error", error);
      });
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this7 = this;

      this.$validator.validateAll().then(function (result) {
        if (scope == "addUserRating") {
          if (result && _this7.rating.currentUserRatingDetails.title.length > 0 && _this7.rating.currentUserRatingDetails.content.length > 0) {
            //check if user is logged in from token
            var token = __WEBPACK_IMPORTED_MODULE_11__services_storage_service__["TokenService"].getToken();
            if (scope == "addUserRating") {
              if (token == null || token == "") {
                _this7.rating.currentUserRatingDetails.currentUserRating = _this7.rating._currentUserRatingDetails.currentUserRating;
                _this7.checkSignIn();
                // open sign in modal
                // return;
              }
              var payload = {
                MovieID: _this7.movieID,
                Title: _this7.rating.currentUserRatingDetails.title,
                Rating: _this7.rating.currentUserRatingDetails.currentUserRating,
                Review: _this7.rating.currentUserRatingDetails.content
              };
              Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/AddRatings", "POST", token, payload).then(function (response) {
                var error = response.error,
                    res = response.res;

                if (res.data.Status) {
                  // if (x.MovieId == this.movieID) {
                  _this7.userRating = parseInt(_this7.ratingDetails.currentUserRating = true);
                  // }
                  _this7.isError = false;
                  _this7.isSuccess = true;
                  setTimeout(function () {
                    _this7.isSuccess = false;
                  }, 3000);
                  _this7.fetchUserReview();
                  _this7.reviewSuccessMessage = "Thank you for your review, it is under moderation";
                } else {
                  _this7.reviewErrorMessage = res.data.Message;
                }
              }).catch(function (error) {
                _this7.reviewErrorMessage = error;
                console.log("Error", error);
              });
              // eslint-disable-next-line
              return;
            }
          } else {
            _this7.isError = true;
            return false;
          }
        }
      });
      // addOnlyUserRating
      this.$validator.validateAll().then(function (result) {
        if (scope == "addOnlyUserRating") {
          //check if user is logged in from token
          var token = __WEBPACK_IMPORTED_MODULE_11__services_storage_service__["TokenService"].getToken();
          if (scope == "addOnlyUserRating") {
            if (token == null || token == "") {
              _this7.rating.currentUserRatingDetails.currentUserRating = _this7.rating._currentUserRatingDetails.currentUserRating;
              _this7.checkSignIn();
              // open sign in modal
              // return;
            }
            var payload = {
              MovieID: _this7.movieID,
              Title: _this7.rating.currentUserRatingDetails.title,
              Rating: _this7.rating.currentUserRatingDetails.currentUserRating,
              Review: _this7.rating.currentUserRatingDetails.content
            };
            Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/AddRatings", "POST", token, payload).then(function (response) {
              var error = response.error,
                  res = response.res;

              if (res.data.Status) {
                // if (x.MovieId == this.movieID) {
                _this7.userRating = parseInt(_this7.ratingDetails.currentUserRating = true);
                // }
                _this7.isError = false;
                _this7.isSuccess = true;
                setTimeout(function () {
                  _this7.isSuccess = false;
                }, 3000);
                _this7.fetchUserReview();
                _this7.reviewSuccessMessage = "Thank you for your review, it is under moderation";
              } else {
                _this7.reviewErrorMessage = res.data.Message;
              }
            }).catch(function (error) {
              _this7.reviewErrorMessage = error;
              console.log("Error", error);
            });
            // eslint-disable-next-line
            return;
          }
        }
      });
    },
    ready: function ready(event) {
      this.player = event.target;
    },
    getRatingContent: function getRatingContent() {
      var _this8 = this;

      var MovieID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload, _ref, error, res;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = { MovieID: MovieID };
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/GetRatingContent", "POST", null, payload);

              case 3:
                _ref = _context.sent;
                error = _ref.error;
                res = _ref.res;

                if (!error && res.data && res.data.Status && res.data.Data) {
                  _this8.ratingContent = res.data.Data;

                  if (_this8.ratingContent) {
                    // this.$refs.tncModal && this.$refs.tncModal.show()
                  }
                } else {
                  console.error({ error: error });
                  _this8.$refs.tncModal && _this8.$refs.tncModal.hide();
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this8);
      }))();
    },
    fetchMovieDetails: function fetchMovieDetails() {
      var _this9 = this;

      //this.showLoading();
      this.showLoading();
      var token = null;
      var payload = {
        MovieID: this.movieID
      };
      // if (this.$persistStore.get("accessToken")) {
      //   token = this.$persistStore.get("accessToken");
      //   payload["access_token"] = token;
      // }
      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/GetShowDetails", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data) {
          if (!error) {
            _this9.movieDetails = res.data.Show[0];
            console.log("Just Checked", _this9.movieDetails);
            _this9.shareURL = res.data.MovieShareURL;
            _this9.pageTitle = _this9.movieDetails.title;
            _this9.jsonld = res.data.meta;
            if (_this9.movieDetails.CategoryID == 3) {
              _this9.tabIndex = 0;
              _this9.getShowTimings();
            } else {
              _this9.hideLoading();
            }
            console.log("this.movieDetails.CategoryID :", _this9.movieDetails.CategoryID);
            // this.jsonld.name = this.movieDetails.title;
            // this.jsonld.description = this.movieDetails.plot;
            // console.log(this.jsonld.actor.length);
            // $.each(this.movieDetails.cast, function(key, value){
            //   if(value.CastType == "Actor") {
            //     console.log(value.Name+" - "+this.jsonld.actor.length);
            //     //this.jsonld.actor.push({"@type":"Person", "name":value.Name});
            //   }
            // });
            // this.movieDetails.cast.map(value=>{
            //     console.log(value.CastType)
            //   if(value.CastType == "Actor") {
            //     this.jsonld.actor.push({"@type":"Person", "name":value.Name});
            //   }
            //   else if(value.CastType == "Director"){
            //     this.jsonld.director.push({"@type":"Person", "name":value.Name});
            //   }
            // });
            // this.selectedFormat = this.movieDetails.format;
            // this.movieDetails.cast.map(x => {
            //   this.movieCast.push(x.Name);
            //   console.log("this.movieCast :", this.movieCast);
            // });

            if (_this9.movieDetails.cat_id != 2) {
              // this.getShowDates();
            }
            if (_this9.movieDetails.videos && _this9.movieDetails.videos.length > 0) {
              if (_this9.$route.params.attr = "search") {
                _this9.youtubes = [];
              }
              _this9.movieDetails.videos.map(function (url) {
                _this9.youtubes.push({
                  thumbnail: "https://img.youtube.com/vi/" + url + "/0.jpg",
                  url: "https://www.youtube.com/watch?v=" + url
                });
              });
            }
            _this9.trailer.thumbnail = "https://img.youtube.com/vi/" + _this9.movieDetails.video + "/0.jpg";
            _this9.trailer.url = "https://www.youtube.com/watch?v=" + _this9.movieDetails.video;
            _this9.format = _this9.movieDetails.format.split(",");
            _this9.format.push("All Formats");
            //this.hideLoading();
            var desc = _this9.movieDetails.title + " Movie (" + _this9.movieDetails.release + "), " + _this9.movieDetails.genre + " released in " + _this9.movieDetails.lang + ". Know about Film reviews, lead cast & crew, photos on Ticketak";

            document.querySelector("title").setAttribute("content", _this9.movieDetails.title + " Movie (" + _this9.movieDetails.release + ") - Ticketak Cinemas");
            // document
            //   .querySelector('meta[name="description"]')
            //   .setAttribute("content", desc);
            // document
            //   .querySelector('meta[name="title"]')
            //   .setAttribute(
            //     "content",
            //     this.movieDetails.title +
            //       " Movie (" +
            //       this.movieDetails.release +
            //       ") - Ticketak Cinemas"
            //   );
            // document
            //   .querySelector('meta[property="og:description"]')
            //   .setAttribute("content", desc);
            // document
            //   .querySelector('meta[property="og:image"]')
            //   .setAttribute("content", this.movieDetails.AppImageMovies);

            // this.language = this.movieDetails.lang.split(",");
            // this.movieDetails.IMDBRating = Math.round(
            //   parseFloat(this.movieDetails.IMDBRating.split("/")[0])
            // );
            // this.$refs.slick1.destroy();
            // this.$nextTick(() => {
            //   this.$refs.slick1.create();
            //   this.$refs.slick1.goTo(1, true);
            // });
            // this.movieDetails.genre.map(x => {
            //   this.movieCast.push(x.Name);
            //   console.log("this.movieCast :", this.movieCast);
            // });
            // this.movieDetails.IMDBRating = Math.round(
            //   parseFloat(this.movieDetails.IMDBRating)
            // );
            // if (this.movieDetails.Trailers && this.movieDetails.Trailers[0]) {
            //   this.youtube =
            //     "https://www.youtube.com/embed/" +
            //     this.movieDetails.Trailers[0].URI;
            // }
            // this.userRatingDetails.user = this.movieDetails.YourRating;
            // console.log("y", this.youtube);
          }
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        _this9.hideLoading();
        console.log("Error", error);
      }).then(function () {
        return _this9.getRatingContent(_this9.movieID);
      }).catch(function (error) {
        console.log("Error", error);
      });
    },


    onclickShare: function onclickShare() {
      FB.ui({
        method: "share",
        href: this.shareURL
      }, function (response) {
        console.log(response);
      });
    },
    onClickTwitterShare: function onClickTwitterShare() {
      var txt = this.shareURL;
      var url2 = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(txt);

      newwindow = window.open(url2, "ABCD", "height=450,width=650");
      if (window.focus) {
        newwindow.focus();
      }
    },
    getStringDate: function getStringDate(addDay) {
      var date = new Date();
      if (addDay) {
        date.setDate(date.getDate() + 1);
      }
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      // var month = monthIndex + 1;
      day = day < 10 ? "0" + day : day;
      // return year + "-" + month + "-" + day;
      return day + " " + monthNames[monthIndex] + " " + year;
    },
    getShowDates: function getShowDates() {
      var _this10 = this;

      var payload = {
        MovieID: this.$route.params.movieID
      };
      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/GetShowDates/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data) {
          _this10.allDates = res.data.Dates;
          for (var i in _this10.allDates) {
            if (_this10.allDates[i].ShowDate == _this10.getStringDate(false)) {
              _this10.allDates[i].ShowDate = "Today";
            }
            if (_this10.allDates[i].ShowDate == _this10.getStringDate(true)) {
              _this10.allDates[i].ShowDate = "Tomorrow";
            }
          }

          // this.allDates[0].Date = "Today";
          // if (this.allDates.length > 1) {
          //   this.allDates[1].Date = "Tomorrow";
          // }
          _this10.selectedDate.Date = _this10.allDates[0].ShowDate;
          _this10.allDates = _this10.allDates.filter(function (x, index) {
            return index < 7;
          });
          _this10.selectedDate.ID = _this10.allDates[0].ID;
          _this10.getShowTimings();
          _this10.allDates.map(function (x) {
            _this10.getCinemas(_this10.selectedDate.ID);
          });
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getCinemas: function getCinemas(dateId) {
      var _this11 = this;

      var payload = {
        MovieID: this.$route.params.movieID,
        DateID: dateId,
        OrganizationID: 3
      };
      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])(this.CinemaAPIPath, "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data) {
          _this11.allcinemas = res.data.Data;
          _this11.allcinemas.push({ name: "All Cinemas" });
          // this.selectedCinema = this.allcinemas[0].name;
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getShowTimings: function getShowTimings() {
      var _this12 = this;

      this.isShowsLoaded = false;
      this.allShows = [];
      this.shows = [];
      this.tempShows = [];
      var payload = {
        MovieID: this.$route.params.movieID,
        DateID: this.selectedDate.ID,
        movie_language: this.movie_language,
        OrganizationID: 3

      };
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.selectedFilter).map(function (x) {
        if (_this12.selectedFilter[x].length > 0) {
          payload[x] = _this12.selectedFilter[x].toString();
        }
      });
      // if (this.cinemaID !== "0") {
      //   payload["cinema_name"] = this.cinemaID;
      // }


      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])(this.CinemaAPIPath, "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data) {
          _this12.shows = res.data.Data;
          _this12.tempShows = res.data.Data;
          _this12.ShowLang = res.data.ShowLangPlaying;
          if (_this12.ShowLang.length > 1 && _this12.movie_language == "") {
            _this12.$refs.LangModal.show();
          }
          if (_this12.tempShows.length > 0) {
            var _loop = function _loop(q) {
              var addedScreenIds = [];
              _this12.tempShows[q]["screenWiseTimeings"] = [];

              var _loop2 = function _loop2(p) {
                if (!addedScreenIds.includes(_this12.tempShows[q].timings[p].screenid)) {
                  var screenName = _this12.tempShows[q].timings.filter(function (z) {
                    return z.screenid == _this12.tempShows[q].timings[p].screenid;
                  });
                  if (screenName.length > 0) {
                    // this.shows[q].screenWiseTimeings.push(screenName);
                    _this12.tempShows[q].screenWiseTimeings.push(screenName);
                    addedScreenIds.push(_this12.tempShows[q].timings[p].screenid);
                  }
                }
                //  console.log(addedScreenIds, "hhhh");
              };

              for (var p = 0; p < _this12.tempShows[q].timings.length; p++) {
                _loop2(p);
              }
            };

            for (var q = 0; q < _this12.tempShows.length; q++) {
              _loop(q);
            }
            _this12.shows = _this12.tempShows;
          }
          _this12.isShowsLoaded = true;
          if (_this12.selectedOrgId == "0") {
            _this12.hideLoading();
            return false;
          }
          var selectedOrgCinemasShows = _this12.shows.filter(function (y) {
            return y.OrganizationID == _this12.selectedOrgId;
          });

          if (selectedOrgCinemasShows.length > 0) {
            _this12.shows = selectedOrgCinemasShows;
          } else {
            _this12.shows = [];
          }

          console.log(_this12.tempShows, "hhhh");

          _this12.hideLoading();
          _this12.isShowsLoaded = true;
        } else {
          _this12.isShowsLoaded = true;
          console.log("Response Error ");
          _this12.hideLoading();
        }
      }).catch(function (error) {
        _this12.isShowsLoaded = true;
        console.log("Error", error);
        _this12.hideLoading();
      });
    },
    stopYoutube: function stopYoutube() {
      this.player.stopVideo();
    },
    fetchUserFav: function fetchUserFav() {
      var _this13 = this;

      var token = __WEBPACK_IMPORTED_MODULE_11__services_storage_service__["TokenService"].getToken();
      if (token) {
        var payload = {
          access_token: token
        };
        Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/api/GetFavourite/", "POST", null, payload).then(function (response) {
          var error = response.error,
              res = response.res;

          if (!error) {
            var Favs = res.data.List;
            Favs.map(function (x) {
              if (x.MovieId == _this13.movieID) {
                _this13.favChecked = true;
              }
            });
          } else {
            _this13.checkSignIn();
            console.log("User not loggedIn");
          }
        }).catch(function (error) {
          console.log("Error", error);
        });
      }
    },
    fetchUserReview: function fetchUserReview() {
      var _this14 = this;

      var token = __WEBPACK_IMPORTED_MODULE_11__services_storage_service__["TokenService"].getToken();
      var payload = {
        MovieID: this.movieID,
        UserReview: false
      };
      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/GetRatings", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data) {
          var array_move = function array_move(arr, old_index, new_index) {
            if (new_index >= arr.length) {
              var k = new_index - arr.length + 1;
              while (k--) {
                arr.push(undefined);
              }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; // for testing
          };
          // let index = this.rating.userRatings.findIndex(x => x.Flag == 1);
          // array_move(this.rating.userRatings, index, 0);


          _this14.rating.userRatings = res.data.RatingList;
          res.data.RatingList.map(function (rating) {
            if (rating.Flag == 1) {
              _this14.rating._currentUserRatingDetails.currentUserRating = parseFloat(rating.Rating);
              _this14.rating._currentUserRatingDetails.title = rating.Title;
              _this14.rating._currentUserRatingDetails.content = rating.Review;
              _this14.rating.currentUserRatingDetails.currentUserRating = parseFloat(rating.Rating);
              _this14.rating.currentUserRatingDetails.title = rating.Title;
              _this14.rating.currentUserRatingDetails.content = rating.Review;
            }
          });
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    fetchCtricReview: function fetchCtricReview() {
      var _this15 = this;

      var payload = {
        MovieID: this.$route.params.movieID
      };
      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/GetCriticRatings", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data) {
          _this15.rating.criticRatings = res.data.Reviews;
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    addtoFav: function addtoFav() {
      var _this16 = this;

      var token = __WEBPACK_IMPORTED_MODULE_11__services_storage_service__["TokenService"].getToken();
      if (token) {
        var payload = {
          MovieID: this.movieID,
          Like: 1,
          FireBaseID: "",
          favourite: !this.movieDetails.favourite
        };
        Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/AddFavourite", "POST", token, payload).then(function (response) {
          var error = response.error,
              res = response.res;

          if (res.data) {
            _this16.ratingMessage = res.data.Message;
            // if (x.MovieId == this.movieID) {
            _this16.favChecked = true;
            if (_this16.movieDetails.favourite == true) {
              parseInt(_this16.movieDetails.interestedcount--);
            } else {
              parseInt(_this16.movieDetails.interestedcount++);
            }
            _this16.movieDetails.favourite = !_this16.movieDetails.favourite;
            // }
            // this.favChecked = true;
          } else {
            _this16.ratingMessage = res.data.Message;
          }

          setTimeout(function () {
            _this16.ratingMessage = "";
          }, 3000);
        }).catch(function (error) {
          _this16.ratingMessage = "Something went wrong";
        });
      } else {
        this.checkSignIn();
      }
    },
    submitReview: function submitReview() {},


    //  Events
    getAllData: function getAllData() {
      var _this17 = this;

      //this.showLoading();

      Object(__WEBPACK_IMPORTED_MODULE_12__helper_internet_js__["makeRequest"])("/v1/event/getAllEvent", "POST", null, null, __WEBPACK_IMPORTED_MODULE_18__helper_constant__["EVENT_URL"]).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error) {
          // this.hideLoading();

          console.log("Ruchi Data", res.data.now_showing);
          _this17.event_img_base_url = res.data.base_url;
          // this.eventBanners = res.data.banners;
          // this.upCommingEvents = res.data.comming_soon.data;
          // this.nowShowingEvents = res.data.now_showing.data;
          _this17.allShowingEvents = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.data.now_showing));
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    goToEventDetails: function goToEventDetails(data) {
      console.log("Event Details", data);
      this.$router.push({
        name: "eventDetails",
        params: {
          eventID: data.event_id
        }
      });
    }
  }
});

/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1134);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1036)("14c85a2b", content, true, {});

/***/ }),

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1035)(true);
// imports


// module
exports.push([module.i, ".filter-list li{padding:15px 40px}.filter-list li input:after{content:\"\"!important;height:0;width:0}", "", {"version":3,"sources":["/var/www/html/cineco/website/vue-pwa-initial-setup/src/components/pages/movieDetails.vue"],"names":[],"mappings":"AACA,gBACE,iBAAmB,CACpB,AACD,4BACE,qBAAuB,AACvB,SAAU,AACV,OAAS,CACV","file":"movieDetails.vue","sourcesContent":["\n.filter-list li {\n  padding: 15px 40px;\n}\n.filter-list li input::after {\n  content: \"\" !important;\n  height: 0;\n  width: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1036)("559a9dee", content, true, {});

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1035)(true);
// imports


// module
exports.push([module.i, ".my-tooltip-class[data-v-4e3b7f4c]{display:none}.filter-list li[data-v-4e3b7f4c]{padding:15px 40px}.filter-list li input[data-v-4e3b7f4c]:after{content:\"\"!important;height:0;width:0}", "", {"version":3,"sources":["/var/www/html/cineco/website/vue-pwa-initial-setup/src/components/pages/movieDetails.vue"],"names":[],"mappings":"AACA,mCACE,YAAc,CACf,AACD,iCACE,iBAAmB,CACpB,AACD,6CACE,qBAAuB,AACvB,SAAU,AACV,OAAS,CACV","file":"movieDetails.vue","sourcesContent":["\n.my-tooltip-class[data-v-4e3b7f4c] {\n  display: none;\n}\n.filter-list li[data-v-4e3b7f4c] {\n  padding: 15px 40px;\n}\n.filter-list li input[data-v-4e3b7f4c]::after {\n  content: \"\" !important;\n  height: 0;\n  width: 0;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isRTL ? 'ltr' : ''},[_c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.jsonld)}}),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper_mob"},[_c('b-modal',{ref:"LangModal",staticClass:"country-modal",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"LangModal","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"},[_vm._v("Choose movie language")]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"row"},_vm._l((_vm.ShowLang),function(Lang,Langindex){return _c('div',{key:Langindex,staticClass:"mb-2 text-white col",on:{"click":function($event){return _vm.setLanguage(Lang, Langindex)}}},[_c('b-button',{staticClass:"btn-white cursor-pointer",staticStyle:{"width":"130px"}},[_vm._v(_vm._s(Lang.Title))])],1)}),0)])]),_vm._v(" "),_c('b-modal',{ref:"LateNightPopup",staticClass:"country-modal",attrs:{"no-close-on-esc":"","hide-header-close":"","id":"LateNightPopup","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"p-3 text-center"},[_c('h5',[_vm._v("This is late night show (Early Hours of Next Day)")]),_vm._v(" "),_c('button',{staticClass:"btn btn-pink",on:{"click":function($event){return _vm.closeLateNightPopup()}}},[_vm._v("\n          OK\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"go-back"},[_c('a',{staticClass:"font-weight-bold",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go back\n      ")])]),_vm._v(" "),_c('section',{staticClass:"movieDetailsBanner"},[(_vm.movieDetails.title)?_c('div',{staticClass:"d-flex cinema_details"},[_c('div',{staticClass:"poster_img"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.movieDetails.movie_card_img),expression:"movieDetails.movie_card_img"}],staticClass:"img-fluid",attrs:{"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"movie_content w-75 mx-2 px-md-3 mt-1 mt-md-3"},[_c('div',{staticClass:"lh-1 mb-md-2 mb-lg-2"},[_c('div',{staticClass:"d-flex flex-wrap align-items-center mb-md-3",class:_vm.isRTL ? 'rtl' : ''},[_c('div',{staticClass:"movieTitle"},[_vm._v(_vm._s(_vm.$t(_vm.movieDetails.title)))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{class:[
                'mb-2 lh-1-5 d-flex flex-wrap',
                _vm.isRTL ? 'rtl alignment-mob' : 'ltr'
              ]},[_c('span',[_vm._v(_vm._s(_vm.movieDetails.rated))]),_vm._v(" "),_c('span',{staticClass:"mx-1"},[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.movieDetails.genre))]),_vm._v(" "),_c('span',{staticClass:"mx-1"},[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.movieDetails.lang))]),_vm._v(" "),_c('span',{staticClass:"mx-1"},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"format_my"},[_vm._v(_vm._s(_vm.movieDetails.format))])]),_vm._v(" "),(
                _vm.movieDetails.hasOwnProperty('plot') &&
                  _vm.movieDetails.plot &&
                  _vm.movieDetails.plot.length > 0
              )?_c('div',{class:['d-none d-xl-flex d-md-block', _vm.isRTL ? 'rtl' : 'ltr'],staticStyle:{"min-height":"65px"}},[_c('read-more',{staticClass:"read-more",attrs:{"more-str":"read more","text":_vm.movieDetails.plot,"link":"#","less-str":"read less","max-chars":200}})],1):_vm._e(),_vm._v(" "),(
                _vm.movieDetails.hasOwnProperty('plot') &&
                  _vm.movieDetails.plot &&
                  _vm.movieDetails.plot.length > 0
              )?_c('div',{staticClass:"d-md-none d-block"},[_c('read-more',{staticClass:"read-more",attrs:{"more-str":"read more","text":_vm.movieDetails.plot,"link":"#","less-str":"read less","max-chars":60}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"movie-info-grid mb-md-3 mb-lg-4 mt-3",class:_vm.isRTL ? 'rtl' : ''},[_c('div',{staticClass:"movieInfo"},[_c('div',{staticClass:"small"},[_vm._v(_vm._s(_vm.$t("RELEASE_DATE")))]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(1076),"height":"16px","width":"16px","alt":""}}),_vm._v("\n                "+_vm._s(_vm.movieDetails.release)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"movieInfo"},[_c('div',{staticClass:"small"},[_vm._v(_vm._s(_vm.$t("RUNTIME")))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(1138),"height":"16px","width":"16px","alt":""}}),_vm._v(" "),_vm._v("\n              "+_vm._s(_vm.movieDetails.runtime)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"movieInfo"},[_c('div',{staticClass:"small"},[_vm._v("IMDB Rating")]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.movieDetails.IMDBRating))])])]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block"},[_c('div',{staticClass:"d-flex mb-md-3 mb-lg-4",class:_vm.isRTL ? 'rtl' : ''})]),_vm._v(" "),_c('div',{staticClass:"mb-md-2 mb-lg-4 d-block d-md-none"},[_c('div',{class:['small d-flex', _vm.isRTL ? 'rtl' : 'ltr']},[_vm._v("\n              "+_vm._s(_vm.$t("MOVIE_TRIALER"))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"d-flex position-relative",class:_vm.isRTL ? 'rtl' : ''},_vm._l((_vm.youtubes),function(trailer,youtubeKey){return _c('div',{key:youtubeKey,staticClass:"mobile-trailer-box"},[_c('a',{staticClass:"btn-play",attrs:{"href":trailer.url,"data-fancybox":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mb-md-2 mb-lg-4 d-none d-md-block"},[_c('div',{class:['small d-flex', _vm.isRTL ? 'rtl' : 'ltr']},[_vm._v("\n              "+_vm._s(_vm.$t("MOVIE_TRIALER"))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"d-flex position-relative",class:_vm.isRTL ? 'rtl' : '',staticStyle:{"min-height":"118px"}},_vm._l((_vm.youtubes),function(trailer,youtubeKey){return _c('div',{key:youtubeKey,staticClass:"trailer-box",style:({
                  'background-image': 'url(' + trailer.thumbnail + ')'
                })},[_c('a',{staticClass:"btn-play",attrs:{"href":trailer.url,"data-fancybox":""}})])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"section-space"}),_vm._v(" "),_c('section',{staticClass:"showtimes-section"},[_c('h4',[_vm._v(_vm._s(_vm.$t("Showdays")))]),_vm._v(" "),(_vm.filters.length > 0)?_c('div',{staticClass:"custom-shadow mt-3"},_vm._l((_vm.filters),function(filter,filterKey){return (filter.filter_key === 'show_date')?_c('div',{key:_vm.index,staticClass:"mob_date_section showtime-date-section"},_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype == 'radio')?_c('div',{key:filterListKey},[_c('div',{staticClass:"showtime-date-btn ",style:({
                color: _vm.selectedDate == filterList.title ? '#fff' : '',
                background:
                  _vm.selectedDate == filterList.title ? 'var(--pink)' : ''
              }),on:{"click":function($event){return _vm.onClickFilter(
                  filter.filter_key,
                  filterList.value,
                  filterListKey,
                  filterList.title
                )}}},[_c('span',[_vm._v(_vm._s(_vm.moment(filterList.title1).format("D")))]),_vm._v(" "),_c('span',{staticClass:"day"},[_vm._v(_vm._s(_vm.moment(filterList.title1).format("MMM")))]),_vm._v(" "),_c('span',{staticClass:"day"},[_vm._v(_vm._s(_vm.moment(filterList.title1).format("ddd")))])])]):_vm._e()}),0):_vm._e()}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pt-3 mx-0 ",class:_vm.isRTL ? 'rtl' : ''},[(false)?_c('div',{staticClass:"col-md-4 col-lg-3 col-xl-2 mb-3 d-none d-md-block"},[_vm._l((_vm.filters),function(filter,filterKey){return _c('div',{key:filterKey,staticClass:"accordian-container"},[_c('button',{staticClass:"btn-accordian no-focus",class:_vm.selectedFilter &&
                _vm.selectedFilter[filter.filter_key] &&
                _vm.selectedFilter[filter.filter_key].length > 0
                  ? 'active'
                  : '',on:{"click":function($event){return _vm.onToggle(filter.collapseId)}}},[_c('img',{attrs:{"src":filter.icon,"height":"15px","width":"15px"}}),_vm._v(" "),(filter.filter_key == 'show_date')?_c('span',[_vm._v(_vm._s(_vm.selectedDate))]):_c('span',[_vm._v(_vm._s(filter.filter_name))])]),_vm._v(" "),_c('b-collapse',{staticClass:"accordian-container",attrs:{"accordion":"my-accordion","role":"tabpanel","id":filter.collapseId}},[_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype == 'radio')?_c('div',{key:filterListKey,staticClass:"btn-accordian-child d-flex align-items-center",on:{"click":function($event){return _vm.onClickFilter(
                    filter.filter_key,
                    filterList.value,
                    filterListKey,
                    filterList.title
                  )}}},[_c('label',[_c('span',{class:_vm.selectedFilter['show_date'] &&
                      filterList.value == _vm.selectedFilter['show_date'][0]
                        ? 'active'
                        : ''},[_vm._v(_vm._s(filterList.title))])])]):_vm._e()}),_vm._v(" "),_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype !== 'radio')?_c('label',{key:filterListKey,staticClass:"btn-accordian-child d-flex align-items-center"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('input',{attrs:{"id":filter.filter_key + filterListKey,"name":"showdate","type":"checkbox"},domProps:{"value":filterList.value,"checked":(_vm.selectedFilter[filter.filter_key] &&
                        filterList.value ==
                          _vm.selectedFilter[filter.filter_key][0]) ||
                      (_vm.selectedFilter['movie_language'] &&
                        filterList.value ===
                          _vm.selectedFilter['movie_language'][0])
                        ? true
                        : false},on:{"click":function($event){return _vm.onClickFilter(
                        filter.filter_key,
                        filterList.value,
                        filterListKey,
                        filterList.title
                      )}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":filter.filter_key + filterListKey,"checked":_vm.selectedFilter[filter.filter_key] &&
                      filterList.value ==
                        _vm.selectedFilter[filter.filter_key][filterKey]
                        ? true
                        : false}},[_vm._v(_vm._s(filterList.title))])])]):_vm._e()})],2)],1)}),_vm._v(" "),_c('Advertise')],2):_vm._e(),_vm._v(" "),(_vm.shows.length > 0)?_c('div',{staticClass:"col-md-4 col-lg-3 col-xl-2 mb-3 d-none"},[_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemas",modifiers:{"cinemas":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(1079),"height":"18px","width":"18px"}}),_vm._v("\n              "+_vm._s(_vm.selectedDate.Date)+"\n            ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"cinemas"}},_vm._l((_vm.allDates),function(singleDate,singleDateKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemas",modifiers:{"cinemas":true}}],key:singleDateKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(singleDate, 'date')}}},[_vm._v("\n                "+_vm._s(singleDate.ShowDate)+"\n              ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemasFilter",modifiers:{"cinemasFilter":true}}],staticClass:"btn-accordian text-over"},[_c('img',{attrs:{"src":__webpack_require__(1080),"height":"18px","width":"18px"}}),_vm._v("\n              "+_vm._s(_vm.selectedCinema)+"\n            ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"cinemasFilter"}},_vm._l((_vm.allcinemas),function(cinema,cinemaKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemasFilter",modifiers:{"cinemasFilter":true}}],key:cinemaKey,staticClass:"btn-accordian-child text-over",on:{"click":function($event){return _vm.filterShowData(cinema.name, 'cinema')}}},[_vm._v("\n                "+_vm._s(cinema.name)+"\n              ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.typeFilter",modifiers:{"typeFilter":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(547),"height":"20px","width":"20px","alt":""}}),_vm._v("\n              "+_vm._s(_vm.selectedFormat)+"\n            ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"typeFilter"}},_vm._l((_vm.format),function(format,formatKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.typeFilter",modifiers:{"typeFilter":true}}],key:formatKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(format, 'format')}}},[_vm._v("\n                "+_vm._s(format)+"\n              ")])}),0)],1),_vm._v(" "),(_vm.language.length > 0)?_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.languageFilter",modifiers:{"languageFilter":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(547),"height":"20px","width":"20px","alt":""}}),_vm._v("\n              "+_vm._s(_vm.selectedLanguage)+"\n            ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"typeFilter"}},_vm._l((_vm.language),function(format,languageKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.languageFilter",modifiers:{"languageFilter":true}}],key:languageKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(_vm.language, 'language')}}},[_vm._v("\n                "+_vm._s(_vm.language)+"\n              ")])}),0)],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-12 px-0"},[_c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"d-md-none d-flex",class:_vm.isRTL ? 'mb-2' : ''},[(_vm.selectedDate != 'Show Date' && false)?_c('div',{staticClass:"badge badge-pill bg-pink text-white",staticStyle:{"font-size":"14px"}},[_vm._v("\n                "+_vm._s(_vm.selectedDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"list-inline d-none"},_vm._l((_vm.filtersChips),function(filter,filterKey){return _c('li',{key:filterKey,staticClass:"list-inline-item"},[_c('div',{staticClass:"badge badge-pill bg-pink text-white"},[_vm._v("\n                    "+_vm._s(filter.title)+"\n                    "),_c('button',{staticClass:"btn-badge-close",on:{"click":function($event){return _vm.onRemoveFilterChips(
                          filter.filter_key,
                          filter.value,
                          filterKey
                        )}}},[_vm._v("\n                      x\n                    ")])])])}),0)]),_vm._v(" "),(_vm.tabIndex == 0)?_c('div',{staticClass:"row pt-3 mx-0 ",class:_vm.isRTL ? 'rtl' : ''},[_c('div',{staticClass:"custom-shadow col-lg-12"},[(_vm.isShowsLoaded == false)?_c('div',{staticClass:"d-flex align-items-center"},[_c('strong',[_vm._v("Please wait...")]),_vm._v(" "),_c('b-spinner',{staticClass:"ml-2",attrs:{"variant":"success"}})],1):_vm._e(),_vm._v(" "),(_vm.shows.length == 0 && _vm.isShowsLoaded == true)?_c('div',[_vm._v("\n                      No Shows Available\n                    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.shows),function(show,showtimeListKey){return _c('div',{key:showtimeListKey},[_c('h6',{staticClass:"font-weight-bold",class:['', _vm.isRTL ? 'rtl' : 'ltr']},[_vm._v("\n                        "+_vm._s(show.name)+"\n                      ")]),_vm._v(" "),_vm._l((show.screenWiseTimeings),function(timingList,timingListKey){return _c('div',{key:timingListKey,staticClass:"showtime-list-grid",class:[_vm.isRTL ? 'pr-0' : '']},[_c('div',[_c('p',[_vm._v("\n                            "+_vm._s(timingList[0].screen_name)+"\n                          ")])]),_vm._v(" "),_c('ul',{staticClass:"showtime-list-items"},_vm._l((timingList),function(timingListNew,timingListKey1){return _c('li',{key:timingListKey1,staticClass:"movie-moon-hover",attrs:{"id":'tooltip' + timingListKey1 + showtimeListKey}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.AvailableSeats
                                  ? 'Available Seats:' + _vm.AvailableSeats
                                  : ''},on:{"click":function($event){return _vm.checkLateNightPopup(
                                  timingListNew.Latenightpopup,
                                  timingListNew,
                                  timingList
                                )}}},[_c('div',{staticClass:"list-li"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('p',[_vm._v("\n                                    "+_vm._s(timingListNew.time)+"\n                                  ")]),_vm._v(" "),(timingListNew.Latenightpopup)?_c('figure',[_c('img',{attrs:{"src":__webpack_require__(292)}})]):_vm._e()]),_vm._v(" "),_c('div',[_c('p',[(timingListNew.format)?_c('span',[_vm._v("( "+_vm._s(timingListNew.format)+" )")]):_vm._e()])])])])])}),0)])})],2)})],2)]):_vm._e(),_vm._v(" "),_c('b-tabs',{staticClass:"movieDetails-tabs pt-3 d-none",class:_vm.isRTL ? 'rtl' : '',model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{staticClass:"show-time-tab",attrs:{"disabled":_vm.shows.length == 0 && _vm.categoryId == 3 ? true : false,"title":"All"},on:{"click":function($event){return _vm.setShows('0')}}},[(_vm.tabIndex == 0)?_c('div',{staticClass:"row pt-3 mx-0 ",class:_vm.isRTL ? 'rtl' : ''},[_c('div',{staticClass:"custom-shadow col-lg-12"},[(_vm.isShowsLoaded == false)?_c('div',{staticClass:"d-flex align-items-center"},[_c('strong',[_vm._v("Please wait...")]),_vm._v(" "),_c('b-spinner',{staticClass:"ml-2",attrs:{"variant":"success"}})],1):_vm._e(),_vm._v(" "),(_vm.shows.length == 0 && _vm.isShowsLoaded == true)?_c('div',[_vm._v("\n                      No Shows Available\n                    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.shows),function(show,showtimeListKey){return _c('div',{key:showtimeListKey},[_c('h6',{staticClass:"font-weight-bold",class:['', _vm.isRTL ? 'rtl' : 'ltr'],on:{"click":function($event){return _vm.filterShowData(show.name, 'cinema')}}},[_vm._v("\n                        "+_vm._s(show.name)+"\n                      ")]),_vm._v(" "),_vm._l((show.screenWiseTimeings),function(timingList,timingListKey){return _c('div',{key:timingListKey,staticClass:"showtime-list-grid",class:[_vm.isRTL ? 'pr-0' : '']},[_c('div',[_c('p',[_vm._v("\n                            "+_vm._s(timingList[0].screen_name)+"\n                          ")])]),_vm._v(" "),_c('ul',{staticClass:"showtime-list-items"},_vm._l((timingList),function(timingListNew,timingListKey1){return _c('li',{key:timingListKey1,staticClass:"movie-moon-hover",attrs:{"id":'tooltip' + timingListKey1 + showtimeListKey}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.AvailableSeats
                                  ? 'Available Seats:' + _vm.AvailableSeats
                                  : ''},on:{"click":function($event){return _vm.checkLateNightPopup(
                                  timingListNew.Latenightpopup,
                                  timingListNew,
                                  timingList
                                )}}},[_c('div',{staticClass:"list-li"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('p',[_vm._v("\n                                    "+_vm._s(timingListNew.time)+"\n                                  ")]),_vm._v(" "),(timingListNew.Latenightpopup)?_c('figure',[_c('img',{attrs:{"src":__webpack_require__(292)}})]):_vm._e()]),_vm._v(" "),_c('div',[_c('p',[(timingListNew.format)?_c('span',[_vm._v("( "+_vm._s(timingListNew.format)+" )")]):_vm._e()])])])])])}),0)])})],2)})],2)]):_vm._e()]),_vm._v(" "),_c('b-tab',{staticClass:"show-time-tab",attrs:{"disabled":_vm.shows.length == 0 && _vm.categoryId == 3 ? true : false,"title":"Cineco"},on:{"click":function($event){return _vm.setShows('3')}}},[(_vm.tabIndex == 1)?_c('div',{staticClass:"row pt-3 mx-0 ",class:_vm.isRTL ? 'rtl' : ''},[(false)?_c('div',{staticClass:"col-md-4 col-lg-3 col-xl-2 mb-3 d-none d-md-block"},[_vm._l((_vm.filters),function(filter,filterKey){return _c('div',{key:filterKey,staticClass:"accordian-container"},[_c('button',{staticClass:"btn-accordian no-focus",class:_vm.selectedFilter &&
                          _vm.selectedFilter[filter.filter_key] &&
                          _vm.selectedFilter[filter.filter_key].length > 0
                            ? 'active'
                            : '',on:{"click":function($event){return _vm.onToggle(filter.collapseId)}}},[_c('img',{attrs:{"src":filter.icon,"height":"15px","width":"15px"}}),_vm._v(" "),(filter.filter_key == 'show_date')?_c('span',[_vm._v(_vm._s(_vm.selectedDate))]):_c('span',[_vm._v(_vm._s(filter.filter_name))])]),_vm._v(" "),_c('b-collapse',{staticClass:"accordian-container",attrs:{"accordion":"my-accordion","role":"tabpanel","id":filter.collapseId}},[_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype == 'radio')?_c('div',{key:filterListKey,staticClass:"btn-accordian-child d-flex align-items-center",on:{"click":function($event){return _vm.onClickFilter(
                              filter.filter_key,
                              filterList.value,
                              filterListKey,
                              filterList.title
                            )}}},[_c('label',[_c('span',{class:_vm.selectedFilter['show_date'] &&
                                filterList.value ==
                                  _vm.selectedFilter['show_date'][0]
                                  ? 'active'
                                  : ''},[_vm._v(_vm._s(filterList.title))])])]):_vm._e()}),_vm._v(" "),_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype !== 'radio')?_c('label',{key:filterListKey,staticClass:"btn-accordian-child d-flex align-items-center"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('input',{attrs:{"id":filter.filter_key + filterListKey,"name":"showdate","type":"checkbox"},domProps:{"value":filterList.value,"checked":(_vm.selectedFilter[filter.filter_key] &&
                                  filterList.value ==
                                    _vm.selectedFilter[filter.filter_key][0]) ||
                                (_vm.selectedFilter['movie_language'] &&
                                  filterList.value ===
                                    _vm.selectedFilter['movie_language'][0])
                                  ? true
                                  : false},on:{"click":function($event){return _vm.onClickFilter(
                                  filter.filter_key,
                                  filterList.value,
                                  filterListKey,
                                  filterList.title
                                )}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":filter.filter_key + filterListKey,"checked":_vm.selectedFilter[filter.filter_key] &&
                                filterList.value ==
                                  _vm.selectedFilter[filter.filter_key][filterKey]
                                  ? true
                                  : false}},[_vm._v(_vm._s(filterList.title))])])]):_vm._e()})],2)],1)}),_vm._v(" "),_c('Advertise')],2):_vm._e(),_vm._v(" "),(_vm.shows.length > 0)?_c('div',{staticClass:"col-md-4 col-lg-3 col-xl-2 mb-3 d-none"},[_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemas",modifiers:{"cinemas":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(1079),"height":"18px","width":"18px"}}),_vm._v("\n                        "+_vm._s(_vm.selectedDate.Date)+"\n                      ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"cinemas"}},_vm._l((_vm.allDates),function(singleDate,singleDateKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemas",modifiers:{"cinemas":true}}],key:singleDateKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(singleDate, 'date')}}},[_vm._v("\n                          "+_vm._s(singleDate.ShowDate)+"\n                        ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemasFilter",modifiers:{"cinemasFilter":true}}],staticClass:"btn-accordian text-over"},[_c('img',{attrs:{"src":__webpack_require__(1080),"height":"18px","width":"18px"}}),_vm._v("\n                        "+_vm._s(_vm.selectedCinema)+"\n                      ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"cinemasFilter"}},_vm._l((_vm.allcinemas),function(cinema,cinemaKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemasFilter",modifiers:{"cinemasFilter":true}}],key:cinemaKey,staticClass:"btn-accordian-child text-over",on:{"click":function($event){return _vm.filterShowData(cinema.name, 'cinema')}}},[_vm._v("\n                          "+_vm._s(cinema.name)+"\n                        ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.typeFilter",modifiers:{"typeFilter":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(547),"height":"20px","width":"20px","alt":""}}),_vm._v("\n                        "+_vm._s(_vm.selectedFormat)+"\n                      ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"typeFilter"}},_vm._l((_vm.format),function(format,formatKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.typeFilter",modifiers:{"typeFilter":true}}],key:formatKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(format, 'format')}}},[_vm._v("\n                          "+_vm._s(format)+"\n                        ")])}),0)],1),_vm._v(" "),(_vm.language.length > 0)?_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.languageFilter",modifiers:{"languageFilter":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(547),"height":"20px","width":"20px","alt":""}}),_vm._v("\n                        "+_vm._s(_vm.selectedLanguage)+"\n                      ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"typeFilter"}},_vm._l((_vm.language),function(format,languageKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.languageFilter",modifiers:{"languageFilter":true}}],key:languageKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(_vm.language, 'language')}}},[_vm._v("\n                          "+_vm._s(_vm.language)+"\n                        ")])}),0)],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-12 px-0"},[_c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"d-md-none d-flex",class:_vm.isRTL ? 'mb-2' : ''},[(_vm.selectedDate != 'Show Date' && false)?_c('div',{staticClass:"badge badge-pill bg-pink text-white",staticStyle:{"font-size":"14px"}},[_vm._v("\n                          "+_vm._s(_vm.selectedDate)+"\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"list-inline d-none"},_vm._l((_vm.filtersChips),function(filter,filterKey){return _c('li',{key:filterKey,staticClass:"list-inline-item"},[_c('div',{staticClass:"badge badge-pill bg-pink text-white"},[_vm._v("\n                              "+_vm._s(filter.title)+"\n                              "),_c('button',{staticClass:"btn-badge-close",on:{"click":function($event){return _vm.onRemoveFilterChips(
                                    filter.filter_key,
                                    filter.value,
                                    filterKey
                                  )}}},[_vm._v("\n                                x\n                              ")])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"custom-shadow"},[(_vm.isShowsLoaded == false)?_c('div',{staticClass:"d-flex align-items-center"},[_c('strong',[_vm._v("Please wait...")]),_vm._v(" "),_c('b-spinner',{staticClass:"ml-2",attrs:{"variant":"success"}})],1):_vm._e(),_vm._v(" "),(_vm.shows.length == 0 && _vm.isShowsLoaded == true)?_c('div',[_vm._v("\n                          No Shows Available\n                        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.shows),function(show,showtimeListKey){return _c('div',{key:showtimeListKey},[_c('h6',{staticClass:"font-weight-bold",class:['', _vm.isRTL ? 'rtl' : 'ltr'],on:{"click":function($event){return _vm.filterShowData(show.name, 'cinema')}}},[_vm._v("\n                            "+_vm._s(show.name)+"\n                          ")]),_vm._v(" "),_vm._l((show.screenWiseTimeings),function(timingList,timingListKey){return _c('div',{key:timingListKey,staticClass:"showtime-list-grid",class:[_vm.isRTL ? 'pr-0' : '']},[_c('div',[_c('p',[_vm._v("\n                                "+_vm._s(timingList[0].screen_name)+"\n                              ")])]),_vm._v(" "),_c('ul',{staticClass:"showtime-list-items"},_vm._l((timingList),function(timingListNew,timingListKey1){return _c('li',{key:timingListKey1,staticClass:"movie-moon-hover",attrs:{"id":'tooltip' + timingListKey1 + showtimeListKey}},[_c('div',{on:{"click":function($event){return _vm.checkLateNightPopup(
                                      timingListNew.Latenightpopup,
                                      timingListNew,
                                      timingList
                                    )}}},[_c('div',{staticClass:"list-li"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('p',[_vm._v("\n                                        "+_vm._s(timingListNew.time)+"\n                                      ")]),_vm._v(" "),(timingListNew.Latenightpopup)?_c('figure',[_c('img',{attrs:{"src":__webpack_require__(292)}})]):_vm._e()]),_vm._v(" "),_c('div',[_c('p',[(timingListNew.format)?_c('span',[_vm._v("(\n                                          "+_vm._s(timingListNew.format)+" )")]):_vm._e()])])])])])}),0)])})],2)})],2),_vm._v(" "),_c('ul',{staticClass:"d-none",class:[
                          'showtime-list mobile_scrollable',
                          _vm.isRTL ? 'pr-0' : 'pl-lg-3'
                        ]},[_vm._l((_vm.filters),function(filter,filterKey){return (filter.filter_key === 'show_date')?_c('div',{staticClass:"d-flex flex-md-wrap mob_date_section",staticStyle:{"gap":"10px"}},_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype == 'radio')?_c('div',{key:filterListKey,staticClass:"date_section"},[_c('button',{staticClass:"date_btn",style:({
                                'background-color':
                                  _vm.selectedDate == filterList.title
                                    ? 'var(--pink)'
                                    : 'gray'
                              }),on:{"click":function($event){return _vm.onClickFilter(
                                  filter.filter_key,
                                  filterList.value,
                                  filterListKey,
                                  filterList.title
                                )}}},[_vm._v("\n                              "+_vm._s(filterList.title)+"\n                            ")])]):_vm._e()}),0):_vm._e()}),_vm._v(" "),_vm._l((_vm.shows),function(show,showtimeListKey){return _c('li',{key:showtimeListKey},[_c('h5',{class:[
                              'cinema-name mb-1 d-flex',
                              _vm.isRTL ? 'rtl' : 'ltr'
                            ],staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.filterShowData(show.name, 'cinema')}}},[_vm._v("\n                            "+_vm._s(show.name)+"\n                          ")]),_vm._v(" "),_vm._l((show.screenWiseTimeings),function(timingList,timingListKey){return _c('ol',{key:timingListKey,class:[_vm.isRTL ? 'pr-0' : '']},[_c('div',{staticClass:"m-3"},[_c('p',[_c('small',[_vm._v(_vm._s(timingList[0].screen_name))])])]),_vm._v(" "),_vm._l((timingList),function(timingListNew,timingListKey1){return _c('li',{key:timingListKey1,attrs:{"id":'tooltip' + timingListKey1 + showtimeListKey}},[_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.onAccept(timingListNew, timingList)}}},[_c('p',{staticStyle:{"width":"100%","margin":"0"}},[_vm._v("\n                                  "+_vm._s(timingListNew.time)+"\n                                  "),_c('br'),_vm._v(" "),(timingListNew.format)?_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("("+_vm._s(timingListNew.format)+")")]):_vm._e()])])],1)})],2)})],2)}),_vm._v(" "),(_vm.shows.length == 0)?_c('li',[_vm._v("\n                          "+_vm._s(_vm.$t("NO_SHOWS_FOUND"))+"\n                        ")]):_vm._e()],2)])]),_vm._v(" "),(_vm.shows.length == 0 && false)?_c('div',{staticClass:"pl-5 pt-1"},[_vm._v("\n                    "+_vm._s(_vm.$t("NO_SHOWS_FOUND"))+"\n                  ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('b-tab',{staticClass:"show-time-tab",attrs:{"disabled":_vm.shows.length == 0 && _vm.categoryId == 3 ? true : false,"title":"Mukta"},on:{"click":function($event){return _vm.setShows('7')}}},[(_vm.tabIndex == 2)?_c('div',{staticClass:"row pt-3 mx-0 ",class:_vm.isRTL ? 'rtl' : ''},[(false)?_c('div',{staticClass:"col-md-4 col-lg-3 col-xl-2 mb-3 d-none d-md-block"},[_vm._l((_vm.filters),function(filter,filterKey){return _c('div',{key:filterKey,staticClass:"accordian-container"},[_c('button',{staticClass:"btn-accordian no-focus",class:_vm.selectedFilter &&
                          _vm.selectedFilter[filter.filter_key] &&
                          _vm.selectedFilter[filter.filter_key].length > 0
                            ? 'active'
                            : '',on:{"click":function($event){return _vm.onToggle(filter.collapseId)}}},[_c('img',{attrs:{"src":filter.icon,"height":"15px","width":"15px"}}),_vm._v(" "),(filter.filter_key == 'show_date')?_c('span',[_vm._v(_vm._s(_vm.selectedDate))]):_c('span',[_vm._v(_vm._s(filter.filter_name))])]),_vm._v(" "),_c('b-collapse',{staticClass:"accordian-container",attrs:{"accordion":"my-accordion","role":"tabpanel","id":filter.collapseId}},[_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype == 'radio')?_c('div',{key:filterListKey,staticClass:"btn-accordian-child d-flex align-items-center",on:{"click":function($event){return _vm.onClickFilter(
                              filter.filter_key,
                              filterList.value,
                              filterListKey,
                              filterList.title
                            )}}},[_c('label',[_c('span',{class:_vm.selectedFilter['show_date'] &&
                                filterList.value ==
                                  _vm.selectedFilter['show_date'][0]
                                  ? 'active'
                                  : ''},[_vm._v(_vm._s(filterList.title))])])]):_vm._e()}),_vm._v(" "),_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype !== 'radio')?_c('label',{key:filterListKey,staticClass:"btn-accordian-child d-flex align-items-center"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('input',{attrs:{"id":filter.filter_key + filterListKey,"name":"showdate","type":"checkbox"},domProps:{"value":filterList.value,"checked":(_vm.selectedFilter[filter.filter_key] &&
                                  filterList.value ==
                                    _vm.selectedFilter[filter.filter_key][0]) ||
                                (_vm.selectedFilter['movie_language'] &&
                                  filterList.value ===
                                    _vm.selectedFilter['movie_language'][0])
                                  ? true
                                  : false},on:{"click":function($event){return _vm.onClickFilter(
                                  filter.filter_key,
                                  filterList.value,
                                  filterListKey,
                                  filterList.title
                                )}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":filter.filter_key + filterListKey,"checked":_vm.selectedFilter[filter.filter_key] &&
                                filterList.value ==
                                  _vm.selectedFilter[filter.filter_key][filterKey]
                                  ? true
                                  : false}},[_vm._v(_vm._s(filterList.title))])])]):_vm._e()})],2)],1)}),_vm._v(" "),_c('Advertise')],2):_vm._e(),_vm._v(" "),(_vm.shows.length > 0)?_c('div',{staticClass:"col-md-4 col-lg-3 col-xl-2 mb-3 d-none"},[_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemas",modifiers:{"cinemas":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(1079),"height":"18px","width":"18px"}}),_vm._v("\n                        "+_vm._s(_vm.selectedDate.Date)+"\n                      ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"cinemas"}},_vm._l((_vm.allDates),function(singleDate,singleDateKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemas",modifiers:{"cinemas":true}}],key:singleDateKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(singleDate, 'date')}}},[_vm._v("\n                          "+_vm._s(singleDate.ShowDate)+"\n                        ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemasFilter",modifiers:{"cinemasFilter":true}}],staticClass:"btn-accordian text-over"},[_c('img',{attrs:{"src":__webpack_require__(1080),"height":"18px","width":"18px"}}),_vm._v("\n                        "+_vm._s(_vm.selectedCinema)+"\n                      ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"cinemasFilter"}},_vm._l((_vm.allcinemas),function(cinema,cinemaKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.cinemasFilter",modifiers:{"cinemasFilter":true}}],key:cinemaKey,staticClass:"btn-accordian-child text-over",on:{"click":function($event){return _vm.filterShowData(cinema.name, 'cinema')}}},[_vm._v("\n                          "+_vm._s(cinema.name)+"\n                        ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.typeFilter",modifiers:{"typeFilter":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(547),"height":"20px","width":"20px","alt":""}}),_vm._v("\n                        "+_vm._s(_vm.selectedFormat)+"\n                      ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"typeFilter"}},_vm._l((_vm.format),function(format,formatKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.typeFilter",modifiers:{"typeFilter":true}}],key:formatKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(format, 'format')}}},[_vm._v("\n                          "+_vm._s(format)+"\n                        ")])}),0)],1),_vm._v(" "),(_vm.language.length > 0)?_c('div',{staticClass:"accordian-container"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.languageFilter",modifiers:{"languageFilter":true}}],staticClass:"btn-accordian"},[_c('img',{attrs:{"src":__webpack_require__(547),"height":"20px","width":"20px","alt":""}}),_vm._v("\n                        "+_vm._s(_vm.selectedLanguage)+"\n                      ")]),_vm._v(" "),_c('b-collapse',{staticClass:"btn-accordian-content",attrs:{"id":"typeFilter"}},_vm._l((_vm.language),function(format,languageKey){return _c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.languageFilter",modifiers:{"languageFilter":true}}],key:languageKey,staticClass:"btn-accordian-child",on:{"click":function($event){return _vm.filterShowData(_vm.language, 'language')}}},[_vm._v("\n                          "+_vm._s(_vm.language)+"\n                        ")])}),0)],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-12 px-0"},[_c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"d-md-none d-flex",class:_vm.isRTL ? 'mb-2' : ''},[(_vm.selectedDate != 'Show Date' && false)?_c('div',{staticClass:"badge badge-pill bg-pink text-white",staticStyle:{"font-size":"14px"}},[_vm._v("\n                          "+_vm._s(_vm.selectedDate)+"\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',[_c('ul',{staticClass:"list-inline d-none"},_vm._l((_vm.filtersChips),function(filter,filterKey){return _c('li',{key:filterKey,staticClass:"list-inline-item"},[_c('div',{staticClass:"badge badge-pill bg-pink text-white"},[_vm._v("\n                              "+_vm._s(filter.title)+"\n                              "),_c('button',{staticClass:"btn-badge-close",on:{"click":function($event){return _vm.onRemoveFilterChips(
                                    filter.filter_key,
                                    filter.value,
                                    filterKey
                                  )}}},[_vm._v("\n                                x\n                              ")])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"custom-shadow"},[(_vm.isShowsLoaded == false)?_c('div',{staticClass:"d-flex align-items-center"},[_c('strong',[_vm._v("Please wait...")]),_vm._v(" "),_c('b-spinner',{staticClass:"ml-2",attrs:{"variant":"success"}})],1):_vm._e(),_vm._v(" "),(_vm.shows.length == 0 && _vm.isShowsLoaded == true)?_c('div',[_vm._v("\n                          No Shows Available\n                        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.shows),function(show,showtimeListKey){return _c('div',{key:showtimeListKey},[_c('h6',{staticClass:"font-weight-bold",class:['', _vm.isRTL ? 'rtl' : 'ltr'],on:{"click":function($event){return _vm.filterShowData(show.name, 'cinema')}}},[_vm._v("\n                            "+_vm._s(show.name)+"\n                          ")]),_vm._v(" "),_vm._l((show.screenWiseTimeings),function(timingList,timingListKey){return _c('div',{key:timingListKey,staticClass:"showtime-list-grid",class:[_vm.isRTL ? 'pr-0' : '']},[_c('div',{},[_c('p',[_vm._v("\n                                "+_vm._s(timingList[0].screen_name)+"\n                              ")])]),_vm._v(" "),_c('ul',{staticClass:"showtime-list-items"},_vm._l((timingList),function(timingListNew,timingListKey1){return _c('li',{key:timingListKey1,staticClass:"movie-moon-hover",attrs:{"id":'tooltip' + timingListKey1 + showtimeListKey}},[_c('div',{on:{"click":function($event){return _vm.checkLateNightPopup(
                                      timingListNew.Latenightpopup,
                                      timingListNew,
                                      timingList
                                    )}}},[_c('div',{staticClass:"list-li"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('p',[_vm._v("\n                                        "+_vm._s(timingListNew.time)+"\n                                      ")]),_vm._v(" "),(timingListNew.Latenightpopup)?_c('figure',[_c('img',{attrs:{"src":__webpack_require__(292)}})]):_vm._e()]),_vm._v(" "),_c('div',[_c('p',[(timingListNew.format)?_c('span',[_vm._v("(\n                                          "+_vm._s(timingListNew.format)+" )")]):_vm._e()])])])])])}),0)])})],2)})],2),_vm._v(" "),_c('ul',{staticClass:"d-none",class:[
                          'showtime-list mobile_scrollable',
                          _vm.isRTL ? 'pr-0' : 'pl-lg-3'
                        ]},[_vm._l((_vm.filters),function(filter,filterKey){return (filter.filter_key === 'show_date')?_c('div',{staticClass:"d-flex flex-md-wrap mob_date_section",staticStyle:{"gap":"10px"}},_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype == 'radio')?_c('div',{key:filterListKey,staticClass:"date_section"},[_c('button',{staticClass:"date_btn",style:({
                                'background-color':
                                  _vm.selectedDate == filterList.title
                                    ? 'var(--pink)'
                                    : 'gray'
                              }),on:{"click":function($event){return _vm.onClickFilter(
                                  filter.filter_key,
                                  filterList.value,
                                  filterListKey,
                                  filterList.title
                                )}}},[_vm._v("\n                              "+_vm._s(filterList.title)+"\n                            ")])]):_vm._e()}),0):_vm._e()}),_vm._v(" "),_vm._l((_vm.shows),function(show,showtimeListKey){return _c('li',{key:showtimeListKey},[_c('h5',{class:[
                              'cinema-name mb-1 d-flex',
                              _vm.isRTL ? 'rtl' : 'ltr'
                            ],staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.filterShowData(show.name, 'cinema')}}},[_vm._v("\n                            "+_vm._s(show.name)+"\n                          ")]),_vm._v(" "),_vm._l((show.screenWiseTimeings),function(timingList,timingListKey){return _c('ol',{key:timingListKey,class:[_vm.isRTL ? 'pr-0' : '']},[_c('div',{staticClass:"m-3"},[_c('p',[_c('small',[_vm._v(_vm._s(timingList[0].screen_name))])])]),_vm._v(" "),_vm._l((timingList),function(timingListNew,timingListKey1){return _c('li',{key:timingListKey1,attrs:{"id":'tooltip' + timingListKey1 + showtimeListKey}},[_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.onAccept(timingListNew, timingList)}}},[_c('p',{staticStyle:{"width":"100%","margin":"0"}},[_vm._v("\n                                  "+_vm._s(timingListNew.time)+"\n                                  "),_c('br'),_vm._v(" "),(timingListNew.format)?_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("("+_vm._s(timingListNew.format)+")")]):_vm._e()])])],1)})],2)})],2)}),_vm._v(" "),(_vm.shows.length == 0)?_c('li',[_vm._v("\n                          "+_vm._s(_vm.$t("NO_SHOWS_FOUND"))+"\n                        ")]):_vm._e()],2)])]),_vm._v(" "),(_vm.shows.length == 0 && false)?_c('div',{staticClass:"pl-5 pt-1"},[_vm._v("\n                    "+_vm._s(_vm.$t("NO_SHOWS_FOUND"))+"\n                  ")]):_vm._e()]):_vm._e()])],1),_vm._v(" "),_c('ul',{staticClass:"d-none",class:[
                'showtime-list mobile_scrollable',
                _vm.isRTL ? 'pr-0' : 'pl-lg-3'
              ]},[_vm._l((_vm.filters),function(filter,filterKey){return (filter.filter_key === 'show_date')?_c('div',{staticClass:"d-flex flex-md-wrap mob_date_section",staticStyle:{"gap":"10px"}},_vm._l((filter.all_filter),function(filterList,filterListKey){return (filterList.inputtype == 'radio')?_c('div',{key:filterListKey,staticClass:"date_section"},[_c('button',{staticClass:"date_btn",style:({
                      'background-color':
                        _vm.selectedDate == filterList.title
                          ? 'var(--pink)'
                          : 'gray'
                    }),on:{"click":function($event){return _vm.onClickFilter(
                        filter.filter_key,
                        filterList.value,
                        filterListKey,
                        filterList.title
                      )}}},[_vm._v("\n                    "+_vm._s(filterList.title)+"\n                  ")])]):_vm._e()}),0):_vm._e()}),_vm._v(" "),_vm._l((_vm.shows),function(show,showtimeListKey){return _c('li',{key:showtimeListKey},[_c('h5',{class:['cinema-name mb-1 d-flex', _vm.isRTL ? 'rtl' : 'ltr'],staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.filterShowData(show.name, 'cinema')}}},[_vm._v("\n                  "+_vm._s(show.name)+"\n                ")]),_vm._v(" "),_vm._l((show.screenWiseTimeings),function(timingList,timingListKey){return _c('ol',{key:timingListKey,class:[_vm.isRTL ? 'pr-0' : '']},[_c('div',{staticClass:"m-3"},[_c('p',[_c('small',[_vm._v(_vm._s(timingList[0].screen_name))])])]),_vm._v(" "),_vm._l((timingList),function(timingListNew,timingListKey1){return _c('li',{key:timingListKey1,attrs:{"id":'tooltip' + timingListKey1 + showtimeListKey}},[_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.onAccept(timingListNew, timingList)}}},[_c('p',{staticStyle:{"width":"100%","margin":"0"}},[_vm._v("\n                        "+_vm._s(timingListNew.time)+"\n                        "),_c('br'),_vm._v(" "),(timingListNew.format)?_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("("+_vm._s(timingListNew.format)+")")]):_vm._e()])])],1)})],2)})],2)}),_vm._v(" "),(_vm.shows.length == 0)?_c('li',[_vm._v("\n                "+_vm._s(_vm.$t("NO_SHOWS_FOUND"))+"\n              ")]):_vm._e()],2)],1)]),_vm._v(" "),(_vm.shows.length == 0 && false)?_c('div',{staticClass:"pl-5 pt-1"},[_vm._v("\n          "+_vm._s(_vm.$t("NO_SHOWS_FOUND"))+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"section-space"}),_vm._v(" "),_c('section',{staticClass:"d-none"},[_c('h4',[_vm._v(_vm._s(_vm.$t("Events you might be interested in ")))]),_vm._v(" "),_c('div',{staticClass:"container-fluid pt-3"},[_c('div',{staticClass:"row",class:_vm.isRTL ? 'rtl' : 'ltr'},_vm._l((this.allShowingEvents),function(data,index){return _c('div',{key:index,staticClass:"col-6 col-lg-2 px-2"},[(index < 6)?_c('div',{staticClass:"event-card",on:{"click":function($event){return _vm.goToEventDetails(data)}}},[_c('img',{staticClass:"w-100 event-image-ht",attrs:{"src":_vm.event_img_base_url + data.e_image}}),_vm._v(" "),_c('div',{staticClass:"event-card-details"},[_c('div',[_c('h6',{staticClass:"mb-0 text-truncate"},[_vm._v(_vm._s(data.e_name))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("\n                      "+_vm._s(_vm.moment(data.es_date).format("MMM. D, YYYY"))+" -\n                      "+_vm._s(_vm.moment(data.ee_date).format("MMM. D, YYYY"))+"\n                    ")])])]),_vm._v(" "),_c('div',[_c('div',[_c('p',{staticClass:"text-pink font-weight-bold text-right"},[_vm._v("\n                      "+_vm._s(data.currency)+"\n                      "+_vm._s(data.price)+"\n                    ")])])])])]):_vm._e()])}),0)])])],1),_vm._v(" "),_c('div',{staticClass:"container-fluid d-none"},[_c('div',{staticClass:"col-12 col-lg-12 col-xl-11 mx-auto px-0"},[_c('div',{staticClass:"slider-container w-100 d-flex flex-wrap"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"\n            col-6 col-xl-8\n            h-100\n            d-flex\n            flex-column\n            justify-content-between\n            py-3\n          "},[_c('div',[_c('div',{staticClass:"d-flex align-items-center mb-1"},[_c('div',{staticClass:"slider-title mb-0"},[_vm._v(_vm._s(_vm.movieDetails.title))]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"my-2 text-info"},[_vm._v(_vm._s(_vm.ratingMessage))])])]),_vm._v(" "),_c('div',{staticClass:"row mx-0 mb-3"},[_c('div',{staticClass:"fs-14 text-dark"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.movieDetails.rated))]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.movieDetails.genre))]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.movieDetails.lang))]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"format"},[_vm._v(_vm._s(_vm.movieDetails.format))])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-5 col-xl-3"},[_c('div',{staticClass:"small"},[_vm._v("Release Date")]),_vm._v(" "),_c('div',{staticClass:"movie-release mr-2 d-flex align-items-center"},[_c('img',{staticClass:"mr-1",attrs:{"src":__webpack_require__(1077),"height":"15px","width":"15px"}}),_vm._v("\n                  "+_vm._s(_vm.movieDetails.release)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"small"},[_vm._v("Runtime")]),_vm._v(" "),_c('div',{staticClass:"movie-duration d-flex align-items-center"},[_c('img',{staticClass:"mr-1",attrs:{"src":__webpack_require__(1078),"height":"15px","width":"15px"}}),_vm._v("\n                  "+_vm._s(_vm.movieDetails.runtime)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"small"},[_vm._v("Favourite")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"mr-2",attrs:{"src":__webpack_require__(1037),"height":"15px","width":"15px","alt":"Heart-icon"}}),_vm._v(" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.movieDetails.interestedcount))]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v(" (Times)")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"small"},[_vm._v("Critics Rating")]),_vm._v(" "),_c('star-rating',{attrs:{"show-rating":true,"rating":parseInt(_vm.movieDetails.criticsrating),"increment":0.5,"inline":true,"read-only":true,"active-color":"#e5007d","star-size":13}}),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v(" (13 Votes)")])],1),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"small"},[_vm._v("Overall rating")]),_vm._v(" "),_c('star-rating',{attrs:{"show-rating":true,"rating":2.5,"increment":0.5,"inline":true,"read-only":true,"active-color":"#e5007d","star-size":13}}),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v(" (13 Votes)")])],1),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"small"},[_vm._v("User Rating")]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v("4.3")]),_vm._v(" "),_c('star-rating',{attrs:{"show-rating":false,"inline":true,"increment":0.5,"active-color":"#ffc107","star-size":20},model:{value:(_vm.ratingDetails.currentUserRating),callback:function ($$v) {_vm.$set(_vm.ratingDetails, "currentUserRating", $$v)},expression:"ratingDetails.currentUserRating"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block"},[_c('div',{staticClass:"d-flex justify-content-between align-items-end"},[_c('div',[_c('div',{staticClass:"small"},[_vm._v("Movie Trailer")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},_vm._l((_vm.youtubes),function(trailer,youtubeKey){return _c('div',{key:youtubeKey,staticClass:"trailer-box",style:({
                      'background-image': 'url(' + trailer.thumbnail + ')'
                    })},[_c('a',{staticClass:"btn-play",attrs:{"href":trailer.url,"data-fancybox":""}})])}),0)])])])]),_vm._v(" "),_c('section',{staticClass:"d-md-none w-100 pb-3"},[_c('hr',{staticClass:"mt-0 mb-3"}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row mx-0"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col px-0"},[_c('div',{staticClass:"small"},[_vm._v("Critic Rating")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('star-rating',{attrs:{"show-rating":false,"rating":4.5,"increment":0.5,"inline":true,"read-only":true,"active-color":"#e5007d","star-size":13}})],1),_vm._v(" "),_c('div',{staticClass:"col px-0"},[_c('div',{staticClass:"small"},[_vm._v("Rating IT")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('star-rating',{attrs:{"show-rating":false,"rating":4.5,"increment":0.5,"inline":true,"read-only":true,"active-color":"#e5007d","star-size":13}})],1)])])])])])]),_vm._v(" "),(false)?_c('section',{staticClass:"fixed-filter d-lg-none"},[_c('button',{staticClass:"btn-filter",staticStyle:{"width":"100%"},on:{"click":function($event){_vm.filterModal = !_vm.filterModal}}},[_vm._v("\n      Filter\n    ")])]):_vm._e(),_vm._v(" "),(_vm.filterModal)?_c('section',{staticClass:"filter-modal"},[_c('div',{staticClass:"filter-modalContent"},[_c('nav',[_c('img',{attrs:{"src":__webpack_require__(293),"height":"20px","width":"20px","alt":"Back"},on:{"click":function($event){_vm.filterModal = !_vm.filterModal}}}),_vm._v(" "),_c('h6',[_vm._v("Filter")]),_vm._v(" "),_c('a',{staticClass:"btn-reset",attrs:{"href":""},nativeOn:{"click":function($event){return _vm.onClearAllFilters()}}},[_vm._v("RESET")])]),_vm._v(" "),_vm._l((_vm.filters),function(filter,filterKey){return _c('div',{key:filterKey,staticClass:"accordian-container"},[_c('button',{staticClass:"btn-accordian no-focus",class:_vm.selectedFilter &&
            _vm.selectedFilter[filter.filter_key] &&
            _vm.selectedFilter[filter.filter_key].length > 0
              ? 'active'
              : '',on:{"click":function($event){return _vm.onToggle(filter.collapseId)}}},[_c('img',{attrs:{"src":filter.icon,"height":"15px","width":"15px"}}),_vm._v(" "),(filter.filter_key == 'show_date')?_c('span',[_vm._v(_vm._s(_vm.selectedDate))]):_c('span',[_vm._v(_vm._s(filter.filter_name))])]),_vm._v(" "),_c('b-collapse',{staticClass:"accordian-container",attrs:{"accordion":"my-accordion","role":"tabpanel","id":filter.collapseId}},_vm._l((filter.all_filter),function(filterList,filterListKey){return _c('div',{key:filterListKey,staticClass:"btn-accordian-child d-flex align-items-center"},[(filterList.inputtype == 'radio')?_c('div',[_c('span',{class:filterList.value == _vm.selectedFilter['show_date'][0]
                    ? 'active'
                    : '',on:{"click":function($event){return _vm.onClickFilter(
                    filter.filter_key,
                    filterList.value,
                    filterListKey,
                    filterList.title
                  )}}},[_vm._v(_vm._s(filterList.title))])]):_c('div',{staticClass:"d-flex align-items-center"},[_c('input',{attrs:{"id":filter.filter_key + filterListKey,"name":"showdate","type":"checkbox"},domProps:{"value":filterList.value,"checked":(_vm.selectedFilter[filter.filter_key] &&
                    filterList.value ==
                      _vm.selectedFilter[filter.filter_key][0]) ||
                  (_vm.selectedFilter['movie_language'] &&
                    filterList.value === _vm.selectedFilter['movie_language'][0])
                    ? true
                    : false},on:{"click":function($event){return _vm.onClickFilter(
                    filter.filter_key,
                    filterList.value,
                    filterListKey,
                    filterList.title
                  )}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":filter.filter_key + filterListKey,"checked":_vm.selectedFilter[filter.filter_key] &&
                  filterList.value ==
                    _vm.selectedFilter[filter.filter_key][filterKey]
                    ? true
                    : false}},[_vm._v(_vm._s(filterList.title))])])])}),0)],1)}),_vm._v(" "),_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn-applyFilter no-focus",on:{"click":function($event){_vm.filterModal = !_vm.filterModal}}},[_vm._v("\n          APPLY FILTER\n        ")])])],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"section-space"}),_vm._v(" "),_c('b-modal',{ref:"",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"coronaPopup","centered":"","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"}),_vm._v(" "),_c('div',{staticClass:"mx-2"},[_c('div',{staticClass:"list-group text-white px-4"},[_c('h3',{staticClass:"text-center"},[_vm._v("We Shall Be Back Soon!")]),_vm._v(" "),_c('p',[_vm._v("\n          In the wake of the news about COVID19, we are practicing social\n          distancing. The ticket bookings on our platform will be discontinued\n          temporarily until further notice from our cinema partners! Until\n          then stay safe!\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"btn-light btn active mb-3 center",attrs:{"to":"/"}},[_vm._v("Home")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-md-block"},[_c('div',{staticClass:"d-flex align-items-center mx-2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6 col-xl-4 pl-0 pb-3 pb-md-0"},[_c('div',{staticClass:"col-lg-1 px-0"},[_c('img',{staticClass:"img",attrs:{"src":__webpack_require__(1139),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mt-1 ml-3"},[_c('input',{staticClass:"favourite",attrs:{"type":"checkbox","id":"fav"}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":"fav"}},[_vm._v("Interested")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col px-0"},[_c('div',{staticClass:"small"},[_vm._v("Favourite")]),_vm._v(" "),_c('div',[_vm._v("\n                  1424\n                  "),_c('span',{staticClass:"font-weight-light"},[_vm._v("(Times)")])]),_vm._v(" "),_c('img',{staticClass:"mr-2",attrs:{"src":__webpack_require__(1037),"height":"15px","width":"15px","alt":"Heart-icon"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n                  2.4\n                  "),_c('span',{staticClass:"font-weight-light"},[_vm._v("(15 Votes)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-bold"},[_vm._v("\n                  2.4\n                  "),_c('span',{staticClass:"font-weight-light"},[_vm._v("(159 Votes)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1138:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNTAgNTAiIHdpZHRoPSI1MHB4IiBoZWlnaHQ9IjUwcHgiPjxwYXRoIGQ9Ik0gMjUgMiBDIDEyLjMwOTI5NSAyIDIgMTIuMzA5Mjk1IDIgMjUgQyAyIDM3LjY5MDcwNSAxMi4zMDkyOTUgNDggMjUgNDggQyAzNy42OTA3MDUgNDggNDggMzcuNjkwNzA1IDQ4IDI1IEMgNDggMTIuMzA5Mjk1IDM3LjY5MDcwNSAyIDI1IDIgeiBNIDI1IDQgQyAzNi42MDk4MjQgNCA0NiAxMy4zOTAxNzYgNDYgMjUgQyA0NiAzNi42MDk4MjQgMzYuNjA5ODI0IDQ2IDI1IDQ2IEMgMTMuMzkwMTc2IDQ2IDQgMzYuNjA5ODI0IDQgMjUgQyA0IDEzLjM5MDE3NiAxMy4zOTAxNzYgNCAyNSA0IHogTSAyNC45ODQzNzUgNi45ODYzMjgxIEEgMS4wMDAxIDEuMDAwMSAwIDAgMCAyNCA4IEwgMjQgMjIuMTczODI4IEEgMyAzIDAgMCAwIDIyIDI1IEEgMyAzIDAgMCAwIDIyLjI5NDkyMiAyNi4yOTEwMTYgTCAxNi4yOTI5NjkgMzIuMjkyOTY5IEEgMS4wMDAxIDEuMDAwMSAwIDEgMCAxNy43MDcwMzEgMzMuNzA3MDMxIEwgMjMuNzA4OTg0IDI3LjcwNTA3OCBBIDMgMyAwIDAgMCAyNSAyOCBBIDMgMyAwIDAgMCAyOCAyNSBBIDMgMyAwIDAgMCAyNiAyMi4xNzU3ODEgTCAyNiA4IEEgMS4wMDAxIDEuMDAwMSAwIDAgMCAyNC45ODQzNzUgNi45ODYzMjgxIHoiLz48L3N2Zz4="

/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alita325.5573271.jpg";

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.0ca5eaf90030b7f257d8.js